export default __webpack_public_path__ + "static/Entenda0152-cbcbe1f18cd38040ea71c7a68d4e7efa.jpg";